/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    Error400CodeEnum,
    Error404SamlTokenPostCodeEnum,
    Error403CodeEnum,
    Error504CodeEnum,
    Error500CodeEnum,
} from 'client-code/device-binding-service';
import { ErrorTypes } from './ErrorTypes';
import { SignInError } from './SignInError';

export class SamlTokenError extends SignInError {
    TAG: string = 'SamlTokenError';

    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.message = message;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case Error400CodeEnum.DbsBadRequestParameters:
                this.code = ErrorTypes.SIGN_IN_SAML_BAD_REQUEST_C401;
                this.type = Error400CodeEnum.DbsBadRequestParameters;
                break;
            case Error404SamlTokenPostCodeEnum.DbsResourceNotFound:
                this.code = ErrorTypes.SIGN_IN_SAML_RESOURCE_NOT_FOUND_C402;
                this.type = Error404SamlTokenPostCodeEnum.DbsResourceNotFound;
                break;
            case Error403CodeEnum.DbsInvalidLicenseplate:
                this.code = ErrorTypes.SIGN_IN_SAML_INVALID_LICENSEPLATE_C403;
                this.type = Error403CodeEnum.DbsInvalidLicenseplate;
                break;
            case Error404SamlTokenPostCodeEnum.DbsExpiredLicenseplate:
                this.code = ErrorTypes.SIGN_IN_SAML_EXPIRED_LICENSEPLATE_C404;
                this.type = Error404SamlTokenPostCodeEnum.DbsExpiredLicenseplate;
                break;
            case Error504CodeEnum.DbsIntegrationTimeout:
                this.code = ErrorTypes.SIGN_IN_SAML_INTEGRATION_TIMEOUT_C405;
                this.type = Error504CodeEnum.DbsIntegrationTimeout;
                break;
            case Error500CodeEnum.DbsInternalError:
                this.code = ErrorTypes.SIGN_IN_SAML_INTERNAL_SERVER_ERROR_C406;
                this.type = Error500CodeEnum.DbsInternalError;
                break;
            case Error404SamlTokenPostCodeEnum.DbsDeviceNotBound:
                this.code = ErrorTypes.SIGN_IN_SAML_DEVICE_NOT_BOUND_C409;
                this.type = Error404SamlTokenPostCodeEnum.DbsDeviceNotBound;
                break;
            default:
                this.code = ErrorTypes.SIGN_IN_SAML_UNKNOWN_ERROR_C499;
                this.type = 'SAML_UNKNOWN_ERROR';
        }
    }
}
